import script from "./SmallModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallModal.vue?vue&type=script&setup=true&lang=js"

import "./SmallModal.vue?vue&type=style&index=0&id=182476e2&lang=css"

const __exports__ = script;

export default __exports__